import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import t, { LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "pfi_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && ["en", "id", "fr"].includes(saved)) return saved;
    return "en";
  });

  const setLang = useCallback((newLang) => {
    if (!["en", "id", "fr"].includes(newLang)) return;
    setLangState(newLang);
    try { window.localStorage.setItem(STORAGE_KEY, newLang); } catch (e) {}
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const tr = useCallback((key) => {
    const dict = t[lang] || t.en;
    return dict[key] ?? t.en[key] ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, tr, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
